<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="ClassName" label="班级" min-width="100" />
      <el-table-column prop="StudentNumber" label="学生编号" min-width="120" />
      <el-table-column prop="FullName" label="姓名" />
      <el-table-column prop="Courses" label="选修" min-width="150" show-overflow-tooltip />
      <el-table-column prop="SeatNumber" label="座位号" />
      <el-table-column prop="CardNumber" label="卡号" min-width="110px" />
      <el-table-column prop="Dormitory" label="宿舍号" />
      <el-table-column prop="ParentName1" label="家长姓名1" min-width="100" />
      <el-table-column prop="ContactNumber1" label="联系电话1" min-width="110" />
      <el-table-column prop="ParentName2" label="家长姓名2" min-width="100" />
      <el-table-column prop="Call2" label="联系电话2" min-width="110" />
      <el-table-column prop="ParentName3" label="家长姓名3" min-width="100" />
      <el-table-column prop="ContactNumber3" label="联系电话3" min-width="110" />
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/st/studentclass").default,
      data: [],
      params: {},
      title: "导出 学生班级信息",
    };
  },
  methods: {
    getData(params) {
      this.params = params;
      this.$refs.dialog.isLoading = true;
      this.api.list(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>